<script setup>
const props = defineProps({
  isDataLoading: {
    type: Boolean,
    required: true,
  },
});
</script>

<template>
  <template v-if="isDataLoading">
    <div class="skeleton-box mb-3 skeleton skeleton-title" />
    <div v-for="item in [1, 2, 3, 4, 5]" :key="item" class="skeleton-box w-100 mb-3 skeleton skeleton-main" />
  </template>
  <slot v-else />
</template>

<style scoped>
.skeleton {
  background-color: rgba(190, 190, 190, 0.2);
}

.skeleton-title {
  height: 36px;
  width: 100px;
  margin-top: 44px;
}

.skeleton-main {
  height: 100px;
}
</style>
